<section id="" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="timingForm" (ngSubmit)="onSubmit()" >
            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>Valet Start and End Time:</legend>

                    <div class="col-48 grid-element">
                        <label>Start and End Time</label>
                        <div class="time-range">
                          <div>
                            <input type="time" formControlName="startTime" readonly="true">
                          </div>
                          <div style="text-align: center;">&nbsp;-&nbsp;</div>
                          <div>
                            <input type="time" formControlName="endTime" readonly="true">
                          </div>
                        </div>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Valet Start and End Time</label>
                        <div class="time-range">
                          <div>
                            <input type="time" formControlName="valetStartTime" (change)="handleValetStartTimeChange($event.target.value)">
                          </div>
                          <div style="text-align: center;">&nbsp;-&nbsp;</div>
                          <div>
                            <input type="time" formControlName="valetEndTime" (change)="handleValetEndTimeChange($event.target.value)">
                          </div>
                        </div>
                    </div>
                </fieldset>
            </div>
            <div class="center mt-20">
                <button 
                    class="btn hvr-shrink center" 
                    (click)="$event.preventDefault(); onSubmit()"
                    [disabled]="btnDisabled || !timingForm.valid">
                    Salva
                    <i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>